import React from 'react';

import { Box } from '@primer/components'
import Wave from '../components/wave'
import PriceGithub from '../components/PriceGithub'
import PriceSelfhosted from '../components/PriceSelfhosted'

// cant use <Seo> here as this view is used as a component in other views
// TODO: dont use a view in other views

export default function(props) {
  return (
    <Box className="position-relative">
      <Wave upsideDown={true} />
      <Box style={{background: 'linear-gradient(to right, #363795, #005C97)'}} className="pt-md-6 pb-8" id="price">
        <PriceGithub
          title={'Our price'}
          showCatalogue={props.showCatalogue}
          showDescription={props.showDescription}
        />
      </Box>
    </Box>
  );
}
